<!-- 设备管理 -->
<template>
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="4" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('设备类型')">
                <j-dict-select-tag v-model="queryParam.deviceType" :dictCode="'deviceType'" :showSearch="false" :placeholder="$t('请选择设备类型')" />
              </a-form-item>
            </a-col>
            <a-col :xl="4" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('问题等级')">
                <!-- <a-select v-model="queryParam.problemLevel" placeholder="请选择问题等级" allowClear>
                  <a-select-option :value="1">紧急</a-select-option>
                  <a-select-option :value="2">一般</a-select-option>
                  <a-select-option :value="3">正常</a-select-option>
                </a-select> -->
                <j-dict-select-tag v-model="queryParam.problemLevel" :dictCode="'problemLevel'" :showSearch="false" :placeholder="$t('请选择问题等级')" />
              </a-form-item>
            </a-col>
            <a-col :xl="5" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('状态')">
                <a-select mode="multiple" v-model="queryParam.statusList" max-tag-count="2" :placeholder="$t('请选择状态')" allowClear>
                  <a-select-option :value="0">{{ $t('未确认') }}</a-select-option>
                  <a-select-option :value="1">{{ $t('已确认') }}</a-select-option>
                  <a-select-option :value="2">{{ $t('驳回') }}</a-select-option>
                  <a-select-option :value="3">{{ $t('搁置') }}</a-select-option>
                  <a-select-option :value="4">{{ $t('已完成') }}</a-select-option>
                  <a-select-option :value="5">{{ $t('工单处理中') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="7" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('时间范围')">
                <a-range-picker show-time v-model="date" valueFormat="YYYY-MM-DD HH:mm:ss" @change="onChange" style="width: 100%;" />
              </a-form-item>
            </a-col>
            <a-col :xl="4" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->
  
      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
        <!-- <a-button type="primary" icon="download" @click="handleExportXls('tickets')">导出</a-button> -->
        <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
          <a-button type="primary" icon="import">导入</a-button>
        </a-upload> -->
        <!-- 高级查询区域 -->
        <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px">{{ $t('批量操作') }} <a-icon type="down" /></a-button>
        </a-dropdown>
      </div>
  
      <!-- table区域-begin -->
      <div>
  
        <a-table
          ref="table"
          size="middle"
          :scroll="{x:true}"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          class="j-table-force-nowrap"
          @change="handleTableChange">
  
          <template slot="htmlSlot" slot-scope="text">
            <div v-html="text"></div>
          </template>
          <template slot="imgSlot" slot-scope="text,record">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
            <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
          </template>
          <template slot="fileSlot" slot-scope="text">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
            <a-button
              v-else
              :ghost="true"
              type="primary"
              icon="download"
              size="small"
              @click="downloadFile(text)">
              {{ $t('下载') }}
            </a-button>
          </template>
          <span slot="problemLevel" slot-scope="text">
            <a-tag color="#E53333" v-if="text == 0">{{ filterDictTextByCache('problemLevel',text) }}</a-tag>
            <a-tag color="#FF9900" v-else-if="text == 1">{{ filterDictTextByCache('problemLevel',text) }}</a-tag>
            <a-tag color="#FFE500" v-else-if="text == 2">{{ filterDictTextByCache('problemLevel',text) }}</a-tag>
            <a-tag color="#337FE5" v-else>{{ filterDictTextByCache('problemLevel',text) }}</a-tag>
          </span>
          <span slot="action" slot-scope="text, record">
            <a @click="handleDetail(record)">{{ $t('详情') }}</a>
          </span>
        </a-table>
      </div>
      <AddProblemModal ref="addProblemModalRef"/>
    </a-card>
  </template>
  
  <script>
  
    import '@/assets/less/TableExpand.less'
    import { mixinDevice } from '@/utils/mixin'
    import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    import {
      httpAction,
      getAction,
      postAction
    } from '@/api/manage'
    import {
      filterDictTextByCache
    } from '@/components/dict/JDictSelectUtil';
    import AddProblemModal from './AddProblemModal.vue'
    import JDictSelectTag from '../../../components/dict/JDictSelectTag.vue'
    import JSearchSelectTag from '../../../components/dict/JSearchSelectTag.vue'
  
    export default {
      name: 'lineList',
      mixins:[JeecgListMixin, mixinDevice],
      components: {
        AddProblemModal,
        JDictSelectTag,
        JSearchSelectTag
      },
      data () {
        return {
          description: '问题上报',
          filterDictTextByCache: filterDictTextByCache,
          url: {
            list: "/jeecg-engineering/InspectionWorkOrderController/workOrderList",
          },
          queryParam: {
            source: 3
          },
        }
      },
      created() {},
      computed: {
        columns() {
                    return [
                    {
                      title: '#',
                      dataIndex: '',
                      key:'rowIndex',
                      width:60,
                      align:"center",
                      customRender: (t,r,index) => {
                        return parseInt(index)+1;
                      }
                    },
                    // {
                    //   title:'上报人',
                    //   align:"center",
                    //   dataIndex: 'informant'
                    // },
                    // {
                    //   title:'上报人电话',
                    //   align:"center",
                    //   dataIndex: 'informantPhone'
                    // },
                    {
                      title: this.$t('问题等级'),
                      align:"center",
                      dataIndex: 'problemLevel',
                      scopedSlots: { customRender: 'problemLevel' },
                    },
                    {
                      title: this.$t('设备类型'),
                      align:"center",
                      dataIndex: 'deviceType',
                      customRender: (text) => {
                        return filterDictTextByCache('deviceType',text)
                      }
                    },
                    {
                      title: this.$t('设备名称'),
                      align:"center",
                      dataIndex: 'deviceName'
                    },
                    {
                      title: this.$t('状态'),
                      align:"center",
                      dataIndex: 'status',
                      customRender: (text) => {
                        return { 0: this.$t('未确认'), 1: this.$t('已确认'), 2: this.$t('驳回'), 3: this.$t('搁置'), 4: this.$t('已完成'),5: this.$t('工单处理中') }[text]
                      }
                    },
                    {
                      title: this.$t('创建时间'),
                      align:"center",
                      dataIndex: 'createTime'
                    },
                    {
                      title: this.$t('操作'),
                      dataIndex: 'action',
                      align:"center",
                      fixed:"right",
                      width:150,
                      scopedSlots: { customRender: 'action' }
                    }
                  ]
                  }
      },
      methods: {
        onChange(e){
          this.queryParam.startTime = e[0];
          this.queryParam.endTime = e[1];
          this.loadData();
        },
        // 详情
        handleDetail(row){
          this.$refs.addProblemModalRef.init(row);
        },
        loadData() {
          let params = this.getQueryParams();
          params.informantId = this.$store.getters.userInfo.id;
          postAction(this.url.list, params).then((res) => {
            if (res.success) {
              this.dataSource = res.result.records;
              this.ipagination.total = res.result.total;
            } else {
              this.$message.error(res.message)
            }
          })
        },
        searchReset(){
          this.queryParam = {
            source: 3,
          };
          this.loadData();
        },
      }
    }
  </script>
  <style scoped>
    @import '~@assets/less/common.less';
  </style>